import { __awaiter, __generator } from "tslib";
import getLogin from "./getLogin";
import { isApp, isApple } from "./detector";
import sleep from "./sleep";
var _a = require("@bilibili/js-bridge"), biliBridge = _a.biliBridge, initEnv = _a.initEnv;
if (isApp) {
    initEnv();
}
biliBridge.callNative({
    method: "global.import",
    data: {
        namespace: "auth",
    },
});
export default function getUserInfo() {
    return __awaiter(this, void 0, void 0, function () {
        var userInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!isApp || !window.biliapp)) return [3, 2];
                    return [4, getLogin(false)];
                case 1:
                    userInfo = _a.sent();
                    if (userInfo) {
                        return [2, userInfo.data];
                    }
                    else {
                        throw new Error("未登录");
                    }
                    _a.label = 2;
                case 2: return [2, new Promise(function (resolve, reject) {
                        biliBridge.callNative({
                            method: "auth.getUserInfo",
                            data: {
                                type: "default",
                            },
                            callback: function (userInfo) {
                                if (userInfo.state === "1" || userInfo.state === 1) {
                                    resolve({
                                        uname: userInfo.userName || userInfo.uname,
                                        mid: userInfo.mid,
                                        face: userInfo.face,
                                    });
                                }
                                else {
                                    reject();
                                }
                            },
                        });
                    })];
            }
        });
    });
}
export function universalGetUserInfo() {
    return isApple && isApp
        ? appleUserInfo()
        : getUserInfo()
            .then(function (v) { return v; }, function () { return undefined; })
            .catch();
}
export function appleUserInfo(retry) {
    if (retry === void 0) { retry = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, sleep(500)];
                case 1:
                    _a.sent();
                    return [2, getUserInfo().then(function (v) {
                            console.log("getUserInfo from ios app success, retry count = ", retry, "retry time = ", Date.now(), "userinfo = ", JSON.stringify(v, null, 2));
                            if (retry > 10) {
                                return undefined;
                            }
                            if (!v || !v.face || !v.uname) {
                                return appleUserInfo(retry + 1);
                            }
                            return v;
                        }, function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        console.log("getUserInfo from ios app fail, retry count = ", retry, "retry time = ", Date.now());
                                        if (retry > 10) {
                                            return [2, undefined];
                                        }
                                        return [4, sleep(200 + 100 * retry)];
                                    case 1:
                                        _a.sent();
                                        return [2, appleUserInfo(retry + 1)];
                                }
                            });
                        }); })];
            }
        });
    });
}
//# sourceMappingURL=getUserInfo.js.map